import React, { FC } from 'react';
import { faStopwatch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tag } from 'antd';
import { SearchHighlight } from '../../connected';
import { colorIsDark } from '../../../utils';

interface Props {
  color: string
  label: string
}

const PlanStatus: FC<Props> = ({ label, color }) => (
  <Tag
    style={{ color: colorIsDark(color) ? 'white' : 'black', fontSize: 14, marginRight: 0 }}
    icon={(<FontAwesomeIcon icon={faStopwatch} style={{ marginRight: 4 }} />)}
    color={color}
  >
    <SearchHighlight text={label} />
  </Tag>
);

export default PlanStatus;
